import React from 'react';
import './login.css';
 import { Switcher } from "../../components/switcher"
import { Outlet } from 'react-router-dom';

const FC: React.FC = () => { 
	return (
        <div id="reset-password"> 
            <p className="cd-form-message">Lost your password? Please enter your email address. You will receive a link to create a new password.</p>
            
            <form className="cd-form">
                <p className="fieldset">
                    <label className="image-replace cd-email" htmlFor="reset-email">E-mail</label>
                    <input className="full-width has-padding has-border" id="reset-email" type="email" placeholder="E-mail"/>
                    <span className="cd-error-message">Error message here!</span>
                </p>

                <p className="fieldset">
                    <input className="full-width has-padding" type="submit" value="Reset password"/>
                </p>
            </form>

            <p className="cd-form-bottom-message"><a href="#0">Back to log-in</a></p>
        </div>
  );
};
export default FC